import React from 'react'
import FundraiserBrandDetails from '../../components/User/FundraiserBrandDetail';

const FundraiserBrand = () => {
  return (
    <FundraiserBrandDetails />
  )
}

export default FundraiserBrand;